import React, {useEffect} from 'react';
import qs from "qs";
import {useHistory, useLocation} from "react-router-dom";
import {useSelector} from "react-redux";

const Redirect = () => {
    const { search } = useLocation()
    const userInfo = useSelector(state => state.user)
    const history = useHistory()

    useEffect(() => {
        const { sync_redirect_email } = qs.parse(search.replace(/^\?/, ''))
        if(userInfo){
            if(userInfo?.authorized) {
                if(sync_redirect_email) {
                    history.push(`/`)
                }
            } else {
                if(sync_redirect_email) history.push(`/?sync_redirect_email=${sync_redirect_email}`)
            }
        }
    }, [userInfo])

    return (
        <>
        </>
    );
}

export default Redirect;
